import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import GlobalMixin from "@/mixins/globalMixin";
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import msal from 'vue-msal'
import { PopoverPlugin } from 'bootstrap-vue'
import { isUserLoggedIn, syncUserPermissions } from '@/auth/utils'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
// import '@/@fake-db/db'

// Custom Global Components Registration
import CasePrintableForm from '@/views/organization/case/shared/PrintableForm.vue'
import ComplaintPrintableForm from '@/views/organization/complaint/shared/PrintableForm.vue'
import EvaluationPrintableView from '@/views/habit/confirmation/view/PrintableView.vue'
Vue.component('CasePrintableForm', CasePrintableForm)
Vue.component('ComplaintPrintableForm', ComplaintPrintableForm)
Vue.component('EvaluationPrintableView', EvaluationPrintableView)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.mixin(GlobalMixin)
// Composition API
Vue.use(VueCompositionAPI)
Vue.use(msal, {
  auth: {
    clientId: '0f83071b-71e8-4a57-a2e7-b1c7cd363e0b',
    autoRefreshToken: true
  }
});
Vue.use(PopoverPlugin)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// App.vue elige el layout (y con él, el sidebar) leyendo el $route inicial de Vue Router,
// disponible antes de que el primer guard de navegación termine — así que el refresco de
// userData.permissions tiene que estar resuelto ANTES de montar, no en el guard (ver detalle
// en syncUserPermissions, src/auth/utils.js).
const bootstrap = async () => {
  if (isUserLoggedIn()) await syncUserPermissions()

  new Vue({
    router,
    store,
    i18n,
    msal,
    render: h => h(App),
  }).$mount('#app')
}

bootstrap()

// PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Register service worker
    navigator.serviceWorker.register('/sw.js');
  });
}

// Data storage persistent
if (navigator.storage && navigator.storage.persist) {
  // Check if the app data storage is marked as persistent
  navigator.storage.persisted()
    .then((isPersisted) => {
      // console.log(`Is persisted: ${isPersisted}`)
      if (!isPersisted) {
        // Mark app data storage as persistent
        navigator.storage.persist()
          .then(() => {
            // console.log(`Persisted storage granted: ${response}`)
          })
          .catch((error) => console.log(error))
      }
    })
    .catch((error) => console.log(error))
}